import AutocompleteSingleSelect from './AutocompleteSingleSelect';

export default AutocompleteSingleSelect;
